import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Ensure the translation result is hidden on page load if no document is selected
    const chatSelect = document.querySelector('[data-chat-target="documentSelect"]')
    if (chatSelect && chatSelect.value === 'all') {
      const translationResult = document.getElementById('translationResult')
      if (translationResult) {
        translationResult.classList.add('d-none')
      }
    }
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value.trim()
      if (query) {
        // Hide translation result when searching
        const resultContainer = document.getElementById('translationResult')
        if (resultContainer) {
          resultContainer.classList.add('d-none')
          const originalText = document.getElementById('originalText')
          const translatedText = document.getElementById('translatedText')
          if (originalText) originalText.innerHTML = ''
          if (translatedText) translatedText.innerHTML = ''
        }
        this.element.querySelector("form").requestSubmit()
      }
    }, 300)
  }

  handleSubmit(event) {
    // Hide translation result when form is submitted
    const resultContainer = document.getElementById('translationResult')
    if (resultContainer) {
      resultContainer.classList.add('d-none')
      const originalText = document.getElementById('originalText')
      const translatedText = document.getElementById('translatedText')
      if (originalText) originalText.innerHTML = ''
      if (translatedText) translatedText.innerHTML = ''
    }
  }

  clear(event) {
    event.preventDefault();
  
    // Debug: Log event trigger
    //console.log("Clear button clicked");
  
    // Clear translations first
    const resultContainer = document.getElementById('translationResult');
    const originalText = document.getElementById('originalText');
    const translatedText = document.getElementById('translatedText');
  
    if (resultContainer) {
      resultContainer.classList.add('d-none');
      //console.log("Hiding translationResult");
    }
    if (originalText) {
      originalText.classList.add('d-none');
      //console.log("Hiding originalText");
    }
    if (translatedText) {
      translatedText.classList.add('d-none');
      //console.log("Hiding translatedText");
    }
  
    // Reset chat dropdown to "All Documents"
    const chatSelect = document.querySelector('[data-chat-target="documentSelect"]');
    if (chatSelect) {
      chatSelect.value = 'all';
      chatSelect.dispatchEvent(new Event('change', { bubbles: true }));
      //console.log("Reset chat dropdown");
    }
  
    // Clear the search input and submit the form
    this.inputTarget.value = '';
    //console.log("Cleared search input");
  
    // Debug: Check if form submission is causing issues
    this.element.querySelector("form").submit();
    //console.log("Form submitted");
  }  
}